// extracted by mini-css-extract-plugin
module.exports = {"container":"IconButton_container__2iVYd","action":"IconButton_action__2WDyB","text":"IconButton_text__3Gg7P","actions":"IconButton_actions__2N_3-"};